import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loadUser } from './store/authSlice';
import { fetchSessions } from './store/sessionSlice';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import HomePage from './mobile/HomePage';
import MorePage from './mobile/MorePage';
import SessionsPage from './pages/SessionsPage';
import ChatPage from './pages/ChatPage';
import AutomationsPage from './pages/AutomationsPage';
import WorkflowsPage from './pages/WorkflowsPage';
import SettingsPage from './pages/SettingsPage';
import NotifichePage from './pages/NotifichePage';
import RemindersPage from './pages/RemindersPage';
import CalendarPage from './pages/CalendarPage';
import AddressBookPage from './pages/AddressBookPage';
import ApiPage from './pages/ApiPage';
import AlexaPage from './pages/AlexaPage';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUser()).then(result => {
      if (loadUser.fulfilled.match(result)) dispatch(fetchSessions());
    });
  }, [dispatch]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Si entra solo con un invito; lo stesso link reimposta la password. */}
      <Route path="/invito/:token" element={<AcceptInvitePage />} />
      <Route path="/reimposta/:token" element={<AcceptInvitePage />} />
      <Route path="/*" element={
        <ProtectedRoute>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/more" element={<MorePage />} />
              <Route path="/sessions" element={<SessionsPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/automations" element={<WorkflowsPage />} />
              <Route path="/automations/legacy" element={<AutomationsPage />} />
              <Route path="/automations/:id" element={<WorkflowsPage />} />
              {/* Non «/api»: quel percorso nginx lo manda al server. */}
              <Route path="/servizi" element={<ApiPage />} />
              <Route path="/alexa" element={<AlexaPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/notifiche" element={<NotifichePage />} />
              <Route path="/reminders" element={<RemindersPage />} />
              <Route path="/address-book" element={<AddressBookPage />} />
            </Routes>
          </Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
